export default "__VITE_ASSET__BVxjqC9Y__"